import { useQuery, UnusedSkipTokenOptions } from '@tanstack/react-query'
import {
	GetSmsAutoLogsParams,
	PaginatedSmsAutoTransactionLogsResponse,
} from '@/modules/transaction/types'
import { querySmsAutoLogsOptions } from './options'

export default function useQuerySmsAutoLogs(
	payload: GetSmsAutoLogsParams,
	options?: UnusedSkipTokenOptions<PaginatedSmsAutoTransactionLogsResponse>,
) {
	return useQuery(querySmsAutoLogsOptions(payload, options))
}
